import { Link } from "@tanstack/react-router";
import { ExternalLink } from "lucide-react";
import { PODCAST_CONFIG } from "@/features/podcast/podcast-config";
import { openCookiePreferences } from "@/lib/cookie-consent";

const exploreLinks = [
  { label: "Tienda", to: "/productos/catalogo" as const },
  { label: "Pódcast", to: "/podcast" as const },
  { label: "Mis compras", to: "/productos/mis-compras" as const },
];

const supportLinks = [
  { label: "Soporte", to: "/productos/tickets" as const },
  { label: "Contacto", to: "/contacto" as const },
  { label: "Ingresar", to: "/acceso" as const },
];

const legalLinks = [
  { label: "Centro legal", to: "/legal" as const },
  { label: "Privacidad y datos", to: "/legal/privacidad" as const },
  { label: "Términos de uso y compra", to: "/legal/terminos" as const },
  { label: "Reembolsos", to: "/legal/reembolsos" as const },
  { label: "Descarga y licencia", to: "/legal/licencia" as const },
  { label: "Política de cookies", to: "/legal/cookies" as const },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-white/15 bg-black text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="site-footer-grid">
          <div>
            <Link to="/" className="inline-flex items-center gap-2 text-base font-semibold">
              <span
                aria-hidden="true"
                className="h-10 w-10 rounded-full bg-white bg-[url('/logo.png')] bg-cover bg-center"
              />
              Socrattica
            </Link>
            <p className="mt-3 max-w-xs text-xs leading-5 text-white/75">
              {PODCAST_CONFIG.secondaryTagline} Un capítulo cada jueves. Guías digitales y un
              pódcast para aprender inglés con claridad.
            </p>
            <a
              href="mailto:socrattica@gmail.com"
              className="mt-4 inline-block text-xs text-white/70 underline underline-offset-4 transition hover:text-white"
            >
              socrattica@gmail.com
            </a>
          </div>

          <nav className="text-xs text-white/70" aria-label="Explorar">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-white">
              Explorar
            </p>
            <div className="flex flex-col items-start gap-3">
              {exploreLinks.map((item) => (
                <Link key={item.label} to={item.to} className="transition-colors hover:text-white">
                  {item.label}
                </Link>
              ))}
            </div>
          </nav>

          <nav className="text-xs text-white/70" aria-label="Ayuda">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-white">
              Ayuda
            </p>
            <div className="flex flex-col items-start gap-3">
              {supportLinks.map((item) => (
                <Link key={item.label} to={item.to} className="transition-colors hover:text-white">
                  {item.label}
                </Link>
              ))}
              <a
                href="https://www.sic.gov.co/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 transition-colors hover:text-white"
              >
                Protección al consumidor
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </nav>

          <nav className="text-xs text-white/70" aria-label="Legal">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-white">
              Legal
            </p>
            <div className="flex flex-col items-start gap-3">
              {legalLinks.map((item) => (
                <Link key={item.label} to={item.to} className="transition-colors hover:text-white">
                  {item.label}
                </Link>
              ))}
              <button
                type="button"
                onClick={openCookiePreferences}
                className="cursor-pointer text-left transition-colors hover:text-white"
              >
                Preferencias de cookies
              </button>
            </div>
          </nav>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-white/15 pt-5 text-xs text-white/65 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Socrattica. Todos los derechos reservados.</span>
          <span>Responsable: Roberto Román Lázaro · Colombia</span>
        </div>
      </div>
    </footer>
  );
}
